export default "__VITE_ASSET__CCos7yPp__"